const ApplicationInfoModal = {
  data: () => ({
    showInfo: false
  }),

  methods: {
    showProcessModal() {
      this.showInfo = true
      console.log('Showing process modal')
    }
  }
}

export default ApplicationInfoModal
